export const getRepBaseByProvider = (ctx?: string) => {
  const gallery = process.env.REACT_APP_URL_GALLERY || '';

  let base: string | undefined;
  switch (ctx) {
    case 'artz':
      base = process.env.REACT_APP_URL_ARTZ_SHOP;
      break;
    case 'kids':
      base = process.env.REACT_APP_URL_KIIIDS_ART;
      break;
    case 'brnd':
      base = process.env.REACT_APP_URL_SHOP_BRANDS;
      break;
    case 'russiangallllery':
      base = process.env.REACT_APP_URL_RUSSIAN_GALLERY;
      break;
    case 'zeland':
      base = process.env.REACT_APP_URL_ZELAND_JHONATA;
      break;
    case 'printmediiia':
      base = process.env.REACT_APP_URL_PRINT_MEDIIIA;
      break;
    case 'marketjhonata':
      base = process.env.REACT_APP_URL_MARKET_JHONATA;
      break;
    case 'museumdafes':
      base = process.env.REACT_APP_URL_MUSEUM_DAFES;
      break;
    case 'artdafes':
      base = process.env.REACT_APP_URL_ART_DAFES;
      break;
    case 'astromediiia':
      base = process.env.REACT_APP_URL_ASTRO_MEDIIIA;
      break;
    case 'artfairmediiia':
      base = process.env.REACT_APP_URL_ARTFAIR_MEDIIIA;
      break;
    default:
      base = gallery;
  }

  return base || gallery;
};

const withHttps = (url?: string) => {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  return `https://${url}`;
};

const hasPathBeyondRoot = (url?: string) => {
  if (!url) return false;
  try {
    const { pathname } = new URL(url);
    return Boolean(pathname && pathname !== '/');
  } catch {
    return false;
  }
};

const formatAdditionalLinkParams = (s?: string) => {
  if (!s?.trim()) return '';
  let t = s.trim().replace(/^\/+/, '');
  if (!t) return '';
  if (t.startsWith('&')) return t;
  if (t.startsWith('?')) return `&${t.slice(1)}`;
  return `&${t}`;
};

export function getContentDisplayCardUrl(params: {
  cardId: string;
  templateDataLink?: string;
  cardProviderId?: string;
  additionalLinkPath?: string;
}): string {
  const normalized = withHttps(params.templateDataLink);
  if (hasPathBeyondRoot(normalized)) return normalized;
  const base = getRepBaseByProvider(params.cardProviderId);
  const queryish = formatAdditionalLinkParams(params.additionalLinkPath);
  return `${base}/typography/${params.cardId}${queryish}`;
}
export const getRepBaseByProvider = (ctx?: string) => {
  const gallery = process.env.REACT_APP_URL_GALLERY || '';

  let base: string | undefined;
  switch (ctx) {
    case 'artz':
      base = process.env.REACT_APP_URL_ARTZ_SHOP;
      break;
    case 'kids':
      base = process.env.REACT_APP_URL_KIIIDS_ART;
      break;
    case 'brnd':
      base = process.env.REACT_APP_URL_SHOP_BRANDS;
      break;
    case 'russiangallllery':
      base = process.env.REACT_APP_URL_RUSSIAN_GALLERY;
      break;
    case 'zeland':
      base = process.env.REACT_APP_URL_ZELAND_JHONATA;
      break;
    case 'printmediiia':
      base = process.env.REACT_APP_URL_PRINT_MEDIIIA;
      break;
    case 'marketjhonata':
      base = process.env.REACT_APP_URL_MARKET_JHONATA;
      break;
    case 'museumdafes':
      base = process.env.REACT_APP_URL_MUSEUM_DAFES;
      break;
    case 'artdafes':
      base = process.env.REACT_APP_URL_ART_DAFES;
      break;
    case 'astromediiia':
      base = process.env.REACT_APP_URL_ASTRO_MEDIIIA;
      break;
    case 'artfairmediiia':
      base = process.env.REACT_APP_URL_ARTFAIR_MEDIIIA;
      break;
    default:
      base = gallery;
  }

  return base || gallery;
};

const withHttps = (url?: string) => {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  return `https://${url}`;
};

const hasPathBeyondRoot = (url?: string) => {
  if (!url) return false;
  try {
    const { pathname } = new URL(url);
    return Boolean(pathname && pathname !== '/');
  } catch {
    return false;
  }
};

const formatAdditionalLinkParams = (s?: string) => {
  if (!s?.trim()) return '';
  let t = s.trim().replace(/^\/+/, '');
  if (!t) return '';
  if (t.startsWith('&')) return t;
  if (t.startsWith('?')) return `&${t.slice(1)}`;
  return `&${t}`;
};

export function getContentDisplayCardUrl(params: {
  cardId: string;
  templateDataLink?: string;
  cardProviderId?: string;
  additionalLinkPath?: string;
}): string {
  const normalized = withHttps(params.templateDataLink);
  if (hasPathBeyondRoot(normalized)) return normalized;
  const base = getRepBaseByProvider(params.cardProviderId);
  const queryish = formatAdditionalLinkParams(params.additionalLinkPath);
  return `${base}/typography/${params.cardId}${queryish}`;
}
